<template>
  <div class="login_container" style="margin-top: 30vh">
    <b-row class="login-row">
      <b-col class="text-center">
        <img src="@/assets/logo.png" width="100" height="100" />
        <h3 class="text-white mt-4">J.L. AI® est en cours de mise à jour.</h3>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

export default {
  name: "Maintenance",
  components: { BRow, BCol },
};
</script>

<style></style>
